import React, { useState, useEffect } from "react";

interface DatePeriodButtonsProps {
  selectedPeriod: string;
  loading: boolean;
  onPeriodChange: (period: string) => void;
}

const DatePeriodButtons: React.FC<DatePeriodButtonsProps> = ({
  selectedPeriod,
  loading,
  onPeriodChange,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const periods: { value: string; label: string }[] = [
    { value: "1wk", label: "1wk" },
    { value: "1mth", label: "1mth" },
    { value: "3mth", label: "3mth" },
    { value: "6mth", label: "6mth" },
    { value: "1yr", label: "1 yr" },
  ];

  return (
    <>
      {isMobile ? (
        <select
          value={selectedPeriod}
          onChange={(e) => onPeriodChange(e.target.value)}
          disabled={loading}
          style={{
            padding: "0.75rem",
            borderRadius: "4px",
            border: "1px solid #ccc",
            backgroundColor: "white",
            color: "#333",
            fontSize: "0.875rem",
            fontWeight: "500",
            cursor: "pointer",
            minWidth: "120px",
            outline: "none",
            transition: "all 0.2s ease",
            WebkitAppearance: "none",
            MozAppearance: "none",
            appearance: "none",
            backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 5\"><path d=\"m2 0-2 2h4zm0 5 2-2h-4z\" fill=\"%23666\"/></svg>')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 0.75rem center",
            backgroundSize: "0.65rem auto",
            paddingRight: "2.5rem",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#667eea";
            e.target.style.boxShadow = "0 0 0 2px rgba(102, 126, 234, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#ccc";
            e.target.style.boxShadow = "none";
          }}
        >
          {periods.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      ) : (
        <div className="period-toggle-group">
          {periods.map(({ value, label }) => {
            const isActive = selectedPeriod === value;
            return (
              <button
                key={value}
                type="button"
                className={`period-toggle-btn ${isActive ? "active" : ""}`}
                onClick={() => onPeriodChange(value)}
                disabled={loading}
              >
                {label}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};

export default DatePeriodButtons;
